<template>
  <div class="right">
    <div class="title-box">
      <span class="curr">{{articleDetail.articleTitle}}</span>
    </div>
    <div class="pt-8">
      <div class="editor-content-view" v-html="articleDetail.content"></div>
    </div>
  </div>
</template>
<script>
import {getDetail} from "@/api/article";

export default {
  props: {
    articleId:{
      type: Number,
      default:0
    }
  },
  data() {
    return {
      articleDetail: {},
      articleListUrl: '/list'
    }
  },
  watch: {
    articleId(){
      this.getArticleDetail()
    }
  },
  methods: {
    // 查询文章详情
    getArticleDetail(){
      const _t = this
      getDetail({
        id: _t.articleId
      }).then((result)=>{
        if(result.status === 'OK'){
          _t.articleDetail = result.data
        }
      })
    },
    // 去列表
    goToArticleList(categoryId){
      if(parseInt(this.articleDetail.articleCategoryIds[0]) == categoryId){
        this.$router.push({
          path: this.articleListUrl,
          query: {
            parentId: this.articleDetail.articleCategoryIds[0]
          }
        })
      }else if(parseInt(this.articleDetail.articleCategoryIds[1]) == categoryId){
        this.$router.push({
          path: this.articleListUrl,
          query: {
            parentId: this.articleDetail.articleCategoryIds[0],
            categoryId: this.articleDetail.articleCategoryIds[1]
          }
        })
      }
    }
  },
  created() {
    this.getArticleDetail()
  }
};
</script>
<style lang="less" scoped>
.right {
  width: 905px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
  padding: 30px;
  p {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5f5f6a;
    line-height: 28px;
    margin-bottom: 30px;
  }
  h3 {
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #171717;
    line-height: 30px;
    margin-bottom: 20px;
  }
}

.title-box {
  padding: 0 0 21px 0;
  border-bottom: 1px solid #f8f8fb;
  span {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #909097;
    line-height: 28px;
    margin-right: 40px;
    position: relative;
    &.curr {
      color: #1b252c;
      &::after {
        width: 96px;
        height: 2px;
        background: #0d53bc;
        content: "";
        position: absolute;
        bottom: -20px;
        left: 0;
      }
    }
  }
}
</style>
<style scoped src="./../../style/wangeditor.css?v=2" />
